import React, { useState } from "react";
import "./Home.css";
import assetUrl from "../utils/assetUrl";
import {
  FaWrench,
  FaBoxOpen,
  FaPaw,
  FaCommentDots,
  FaSearch,
  FaMapMarkerAlt,
  FaUsers,
  FaArrowRight,
  FaUpload,
} from "react-icons/fa";
import { useLanguage } from "../i18n";

const categories = [
  { icon: <FaWrench />, titleKey: "skills", textKey: "skillsText", path: "/profiles" },
  { icon: <FaBoxOpen />, titleKey: "materials", textKey: "materialsText", path: "/materials" },
  { icon: <FaPaw />, titleKey: "petsPlants", textKey: "petsPlantsText", path: "/pets" },
  { icon: <FaUsers />, titleKey: "experiences", textKey: "experiencesText", path: "/hangouts" },
  { icon: <FaCommentDots />, titleKey: "advice", textKey: "adviceText", path: "/advice" },
];

function Home({ onNavigate }) {
  const { t } = useLanguage();
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState("");

  const heroVisualStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(37,99,235,0.14), rgba(245,158,11,0.08)), image-set(url("${assetUrl("/img/home-640.webp")}") 1x, url("${assetUrl("/img/home-1280.webp")}") 2x)`,
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const q = encodeURIComponent(search.trim());
    const loc = encodeURIComponent(location.trim());
    if (onNavigate) onNavigate(`/search?query=${q}&location=${loc}`);
  };

  return (
    <div className="home-container page-wrap" id="home">
      <section className="hero card-surface">
        <div className="hero__content">
          <span className="badge">{t("localExchangeCommunity")}</span>

          <h1>{t("heroTitle")}</h1>

          <p>{t("heroText")}</p>

          <form className="hero__search" onSubmit={handleSearch} aria-label={t("search")}>
            <div className="hero__field">
              <label htmlFor="home-search-query" className="sr-only">
                {t("search")}
              </label>
              <FaSearch aria-hidden="true" />
              <input
                id="home-search-query"
                type="text"
                placeholder={t("searchThings")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                aria-label={t("searchThings")}
              />
            </div>

            <div className="hero__field">
              <label htmlFor="home-search-location" className="sr-only">
                {t("location")}
              </label>
              <FaMapMarkerAlt aria-hidden="true" />
              <input
                id="home-search-location"
                type="text"
                placeholder={t("enterLocation")}
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                aria-label={t("enterLocation")}
              />
            </div>

            <button type="submit" className="search-btn ">
              {t("search")}
            </button>
          </form>

          <div className="hero__actions">
            <button
              className="btn-secondary"
              type="button"
              onClick={() => onNavigate && onNavigate("/dashboard")}
            >
              <FaArrowRight aria-hidden="true" /> {t("openYourSpace")}
            </button>

            <button
              className="btn-secondary"
              type="button"
              onClick={() => onNavigate && onNavigate("/upload/material")}
            >
              <FaUpload aria-hidden="true" /> {t("shareSomething")}
            </button>
          </div>
        </div>

        <div className="hero__visual" style={heroVisualStyle}>
          <div className="hero__card">
            <strong>{t("whatYouCanExchange")}</strong>
            <ul>
              <li>{t("exchangePoint1")}</li>
              <li>{t("exchangePoint2")}</li>
              <li>{t("exchangePoint3")}</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="page-hero__copy">
          <h2 className="section-title">{t("browseLocalExchanges")}</h2>
          <p className="page-subtitle">{t("browseLocalSubtitle")}</p>
        </div>

        <div className="categories">
          {categories.map((item) => (
            <button
              key={item.titleKey}
              type="button"
              className="category-card"
              onClick={() => onNavigate && onNavigate(item.path)}
              aria-label={`${t("browseLocalExchanges")} ${t(item.titleKey)}`}
            >
              <div className="category-card__icon">{item.icon}</div>
              <div className="category-card__title">{t(item.titleKey)}</div>
              <div className="category-card__text">{t(item.textKey)}</div>
            </button>
          ))}
        </div>
      </section>

      <section className="home-highlights">
        <div className="highlight card-surface">
          <h3>{t("localExchangeSimple")}</h3>
          <p>{t("localExchangeSimpleText")}</p>
        </div>

        <div className="highlight card-surface">
          <h3>{t("usefulThingsSkills")}</h3>
          <p>{t("usefulThingsSkillsText")}</p>
        </div>

        <div className="highlight card-surface">
          <h3>{t("experiencesTogether")}</h3>
          <p>{t("experiencesTogetherText")}</p>
        </div>
      </section>
    </div>
  );
}

export default Home;